<template>

    <div class="row no-margin mt-3 align-items-center px-2 py-2 border radius-13">
        <!-- <div class="col-sm-6 cursor-pointer w-auto employee-status-link" v-if="previous" @click="setEmployee(previous.employee_id)" style="flex: unset;">
            <b-icon icon="chevron-left"></b-icon>
            <img v-if="previous.pic != ''" v-bind:src="'/avatar/'+ company_id + '/' + previous.pic" class="img-fluid img-thumbnail employee-avatar mx-2" />
            <img v-else v-bind:src="'/avatar/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
            {{previous.name}}
        </div>

        <div class="col-sm-6 cursor-pointer text-right w-auto pr-0 employee-status-link" v-if="next" @click="setEmployee(next.employee_id)" style="flex: unset;">
            {{next.name}}
            <img v-if="next.pic != ''" v-bind:src="'/avatar/'+ company_id + '/' + next.pic" class="img-fluid img-thumbnail employee-avatar mx-2" />
            <img v-else v-bind:src="'/avatar/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
            <b-icon icon="chevron-right"></b-icon>
        </div> -->
        <div class="col-md-3 pl-0" :class="{'d-none': hidebacknext}">
            <button class="btn btn-primary custom-wizard-btn" v-if="previous" @click="setEmployee(previous.employee_id)"><b-icon icon="chevron-left" class="mr-2"></b-icon>Back</button>
        </div>
        <div class="text-center" :class="hidebacknext ? 'col-md-12' : 'col-md-6'">
            <template v-if="public_info">
                <div class="personal-data-text-primary">{{ public_info.name }}</div>
                <div class="personal-data-text-secondery" >
                    <template v-if="public_info.jobposition_id > 0 && public_info.department_id > 0">
                        {{public_info.jobposition}} | {{public_info.department}}
                    </template>
                </div>
            </template>
        </div>
        <div class="col-md-3 pr-0 text-right" :class="{'d-none': hidebacknext}">
            <button class="btn btn-primary" v-if="next" @click="setEmployee(next.employee_id)">Next<b-icon icon="chevron-right" class="ml-2"></b-icon></button>
        </div>
    </div>
</template>

<script>

    export default{

        mounted() {

        },
        props: ['pageurl','public_info', 'hidebacknext'],
        data(){

            return {

                previous : [],
                next : [],

                company_id : 0,

            }
        },
        methods:{
            getEmployeePreviousNextData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/previous-next' , {
                    params: {

                    }
                }).then(function(response){

                    this.company_id = response.data.company_id;
                    this.previous = response.data.prev_employee;
                    this.next = response.data.next_employee;

                }.bind(this));
            },
            setEmployee:function(x)
            {
                if(!this.checkNet()) return false;

                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {
                        location.reload();

                    }.bind(this));

            },


        },
        created: function(){
            this.getEmployeePreviousNextData();
        }
    }
</script>
